module.exports = __webpack_public_path__ + "static/media/rafael.990b877f.jpg";